import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, CheckCircle2, XCircle } from "lucide-react";
import { TopBar } from "@/components/layout/TopBar";

const QUESTIONS = [
  { id: 1, text: "Aide-t-elle le professionnel à prendre une meilleure décision aujourd'hui ?" },
  { id: 2, text: "Aide-t-elle le professionnel à devenir objectivement meilleur au fil du temps ?" },
  { id: 3, text: "Le bénéfice est-il mesurable avec des preuves concrètes ?" },
  { id: 4, text: "Cette fonctionnalité augmente-t-elle la confiance dans ALTIORA ABI ?" },
];

export default function AbiDoctrine() {
  const [featureName, setFeatureName] = useState("");
  const [answers, setAnswers] = useState({ 1: null, 2: null, 3: null, 4: null });

  const decision = () => {
    const vals = Object.values(answers);
    if (vals.some(v => v === null)) return null;
    return vals.every(v => v === true);
  };
  const d = decision();

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#FBF6EA" }}
          data-testid="abi-doctrine-root">
      <TopBar />
      <div className="px-8 pt-8 pb-6"
            style={{ background: "linear-gradient(120deg,#0B2545 0%,#123B6E 100%)" }}>
        <div className="max-w-3xl mx-auto text-white">
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest opacity-80">
            <ShieldCheck size={14} /> Doctrine ALTIORA · v5 · Critères de validation
          </div>
          <h1 className="font-serif text-3xl mt-2" data-testid="abi-doctrine-title">
            Le test 4-questions avant toute nouvelle fonctionnalité
          </h1>
          <p className="text-white/85 mt-3 italic">
            « Si une seule réponse est NON, la fonctionnalité n'est pas prioritaire. »
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-8 py-8 space-y-4">
        <div className="bg-white rounded-lg shadow-sm p-5">
          <label className="text-[13px] uppercase tracking-widest font-bold text-slate-600">
            Nom de la fonctionnalité évaluée
          </label>
          <input type="text" value={featureName}
                  onChange={e => setFeatureName(e.target.value)}
                  placeholder="ex. Weekly Digest Resend"
                  className="w-full mt-1 border rounded px-3 py-2 text-[14px]"
                  data-testid="abi-doctrine-feature" />
        </div>

        {QUESTIONS.map(q => (
          <div key={q.id} className="bg-white rounded-lg shadow-sm p-5"
                data-testid={`abi-doctrine-q${q.id}`}>
            <div className="text-[15px] text-slate-900 mb-3">
              <span className="font-bold" style={{ color: "#7A5B14" }}>
                Question {q.id} · </span>
              {q.text}
            </div>
            <div className="flex gap-2">
              <button onClick={() => setAnswers(a => ({ ...a, [q.id]: true }))}
                      className="px-4 py-1.5 rounded text-[13px] flex items-center gap-1"
                      style={{
                        backgroundColor: answers[q.id] === true ? "#0B7A3B" : "#F3F4F6",
                        color: answers[q.id] === true ? "#fff" : "#5B5B62",
                      }}
                      data-testid={`abi-doctrine-q${q.id}-yes`}>
                <CheckCircle2 size={14} /> Oui
              </button>
              <button onClick={() => setAnswers(a => ({ ...a, [q.id]: false }))}
                      className="px-4 py-1.5 rounded text-[13px] flex items-center gap-1"
                      style={{
                        backgroundColor: answers[q.id] === false ? "#B91C1C" : "#F3F4F6",
                        color: answers[q.id] === false ? "#fff" : "#5B5B62",
                      }}
                      data-testid={`abi-doctrine-q${q.id}-no`}>
                <XCircle size={14} /> Non
              </button>
            </div>
          </div>
        ))}

        {d !== null && (
          <div className="rounded-lg p-5 shadow-sm"
                style={{ backgroundColor: d ? "#DCFCE7" : "#FEE2E2",
                          borderLeft: `4px solid ${d ? "#0B7A3B" : "#B91C1C"}` }}
                data-testid="abi-doctrine-verdict">
            <div className="text-[10px] uppercase tracking-widest font-bold mb-1"
                  style={{ color: d ? "#0B7A3B" : "#B91C1C" }}>
              Verdict doctrinal
            </div>
            <h3 className="font-serif text-xl" style={{ color: "#0B2545" }}>
              {featureName ? `« ${featureName} » — ` : ""}
              {d ? "PRIORITAIRE · à construire." : "NON PRIORITAIRE · à revoir ou reporter."}
            </h3>
            <p className="text-[13px] text-slate-800 mt-2">
              {d ? "Les 4 questions doctrinales sont satisfaites. La fonctionnalité peut entrer en développement."
                  : "Au moins une question doctrinale reçoit un NON. Revoir la conception avant tout développement."}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
